import { render, staticRenderFns } from "./Prealerta.vue?vue&type=template&id=bb1846a2&scoped=true"
import script from "./Prealerta.vue?vue&type=script&lang=js"
export * from "./Prealerta.vue?vue&type=script&lang=js"
import style0 from "./Prealerta.vue?vue&type=style&index=0&id=bb1846a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1846a2",
  null
  
)

export default component.exports